<template>
  <section class="resume-section" id="skills">
    <div class="resume-section-content">
      <h2 class="mb-5">Skills</h2>
    <dl class="row">
      <dt class="col-sm-3">Frameworks</dt>
      <dd class="col-sm-9">
        <p>Android</p>
        <p>Vue</p>
        <p>Angular</p>
        <p>Node</p>
        <p>Unity3D</p>
      </dd>
      <dt class="col-sm-3">Languages</dt>
      <dd class="col-sm-9">
        <p>Java</p>
        <p>Kotlin</p>
        <p>Javascript</p>
        <p>Typescript</p>
        <p>Python</p>
        <p>HTML/CSS/SCSS</p>
      </dd>
      <dt class="col-sm-3 ">Hardware</dt>
      <dd class="col-sm-9">
        <p>Hololens</p>
        <p>Software Defined Radio</p>
        <p>Microcontrollers</p>
        <p>Raspberry Pi</p>
      </dd>
    </dl>
    </div>
  </section>
</template>

<script>
export default {
  name: "Skills"
}
</script>

<style scoped>
h2 {
  text-transform: uppercase;
}
</style>